export type SsdFilterOption = {
  value: string;
  label: string;
  keywords?: string[];
};

export type SsdFilterGroup = {
  id: string;
  label: string;
  options: SsdFilterOption[];
};

export const ssdFilterGroups: SsdFilterGroup[] = [
  {
    id: 'brand',
    label: 'Thương hiệu',
    options: [
      { value: 'samsung', label: 'Samsung', keywords: ['samsung'] },
      { value: 'gigabyte', label: 'Gigabyte', keywords: ['gigabyte'] },
      { value: 'kingston', label: 'Kingston', keywords: ['kingston'] },
      { value: 'wd', label: 'Western Digital', keywords: ['western digital', 'wd'] },
      { value: 'seagate', label: 'Seagate', keywords: ['seagate'] },
      { value: 'lexar', label: 'Lexar', keywords: ['lexar'] },
      { value: 'crucial', label: 'Crucial', keywords: ['crucial'] },
      { value: 'msi', label: 'MSI', keywords: ['msi'] },
      { value: 'corsair', label: 'Corsair', keywords: ['corsair'] },
      { value: 'hiksemi', label: 'Hiksemi', keywords: ['hiksemi'] },
    ],
  },
  {
    id: 'capacity',
    label: 'Dung lượng',
    options: [
      { value: '120-128', label: '120GB - 128GB', keywords: ['120gb', '128gb'] },
      { value: '240-256', label: '240GB - 256GB', keywords: ['240gb', '256gb'] },
      { value: '480-512', label: '480GB - 512GB', keywords: ['480gb', '512gb'] },
      { value: '1tb', label: '1TB', keywords: ['1tb'] },
      { value: '2tb', label: '2TB', keywords: ['2tb'] },
      { value: '4tb', label: 'Trên 4TB', keywords: ['trên 4tb', '4tb', '5tb', '6tb', '8tb'] },
    ],
  },
  {
    id: 'interface',
    label: 'Chuẩn giao tiếp',
    options: [
      { value: 'nvme', label: 'M.2 NVMe PCIe', keywords: ['nvme', 'm.2', 'pcie'] },
      { value: 'sata', label: 'SATA III', keywords: ['sata', 'sata iii'] },
    ],
  },
  {
    id: 'pcie',
    label: 'Thế hệ PCIe',
    options: [
      { value: 'gen3', label: 'Gen 3x4', keywords: ['gen 3', 'gen3', '3x4'] },
      { value: 'gen4', label: 'Gen 4x4', keywords: ['gen 4', 'gen4', '4x4'] },
      { value: 'gen5', label: 'Gen 5x4', keywords: ['gen 5', 'gen5', '5x4'] },
    ],
  },
  {
    id: 'size',
    label: 'Kích thước ổ cứng',
    options: [
      { value: 'm2-2280', label: 'M.2 2280', keywords: ['2280'] },
      { value: 'm2-2230', label: 'M.2 2230', keywords: ['2230'] },
      { value: '2-5', label: '2.5 Inch', keywords: ['2.5', '2.5 inch'] },
    ],
  },
  {
    id: 'nand',
    label: 'Công nghệ bộ nhớ',
    options: [
      { value: '3d-nand', label: '3D-NAND', keywords: ['3d nand', '3d-nand'] },
      { value: 'qlc', label: 'QLC', keywords: ['qlc'] },
      { value: 'slc-mlc', label: 'SLC/MLC', keywords: ['slc', 'mlc'] },
    ],
  },
];
